// --------------------------------------------------------------------------------
// NOTE: This file was automatically generated, do not modify manually.
// --------------------------------------------------------------------------------
import { Volume } from './Volume';
import { VolumePrism } from './VolumePrism';
import { PrismRange } from './PrismRange';
import { Polygon2D } from './Polygon2D';
import { Coordinate } from './Coordinate';

export class Measure implements IMeasure {
    id!: string;
    volumes!: Volume[];
    delayInMinutes!: number;

    constructor(data?: IMeasure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["volumes"])) {
                this.volumes = [] as any;
                for (let item of _data["volumes"])
                    this.volumes!.push(Volume.fromJS(item));
            }
            this.delayInMinutes = _data["delayInMinutes"];
        }
    }

    static fromJS(data: any): Measure {
        data = typeof data === 'object' ? data : {};
        let result = new Measure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.volumes)) {
            data["volumes"] = [];
            for (let item of this.volumes)
                data["volumes"].push(item ? item.toJSON() : <any>undefined);
        }
        data["delayInMinutes"] = this.delayInMinutes;
        return data;
    }
}

export interface IMeasure {
    id: string;
    volumes: Volume[];
    delayInMinutes: number;
}